export class SystemApp {
	public static app = {
		'cv.invision-desktop.ux':  {
			name: 'INvision Desktop',
			logo: 'assets/img/brand/invision-desktop.svg',
			key: 'desktop',
			dependencies: [
				'desktop-intelligence-api',
				'docsys',
				'generate-token',
				'ids',
				'inspection-api',
				'lambda - acuity dispatcher', // 'lambda-acuity-dispatcher-function',
				'lambda - appscope dispatcher messaging', // 'lambda-appscope-dispatcher-messaging', 
				'lambda - database events', // 'lambda-database-events-function',
				'lambda generate zip files', // 'lambda-fnma-generate-photos-zip-file', 
				'lambda image', // 'lambda-fnma-image', 
				'lambda image processor', // 'lambda-image-processor',
				'lambda insidemaps processor data', // 'lambda-insidemaps-processor-data',
				'lambda reports generator', // 'lambda-reports',
				// 'lambda - invision activity report',
				'orders-api',
				'photo-files-api',
				'reports-service',
				'reports-service-ssr',
				'reports-web-app',
				'telemetry-api',
				'users'
			]
		},
		'cv.invision-intelligence.ux': {
			name: 'ClassINtelligence',
			logo: 'assets/img/brand/class-intelligence.svg',
			key: 'intelligence',
			dependencies: [
				'docsys',
				'generate-token',
				'ids',
				'inspection-api',
				'lambda - acuity dispatcher', // 'lambda-acuity-dispatcher-function',
				'lambda - appscope dispatcher', // 'lambda-appscope-dispatcher-function',
				'lambda - appscope dispatcher messaging', // 'lambda-appscope-dispatcher-messaging', 
				'lambda - database events', // 'lambda-database-events-function',
				'lambda complete', // 'lambda-fnma-complete',
				'lambda generate zip files', // 'lambda-fnma-generate-photos-zip-file', 
				'lambda image', // 'lambda-fnma-image', 
				'lambda inject data', // 'lambda-fnma-inject-data',
				'lambda metadata', // 'lambda-fnma-metadata',
				'lambda-freddie-dispatcher-function',
				'lambda image processor', // 'lambda-image-processor',
				'lambda - insidemaps dispatcher', // 'lambda-insidemaps-dispatcher-function', 
				'lambda insidemaps processor data', // 'lambda-insidemaps-processor-data',
				'lambda - intelligence background', // 'lambda-intelligence-background-function',
				'lambda - quicken dispatcher', // 'lambda-quicken-dispatcher',
				'lambda reports generator', // 'lambda-reports',
				// 'lambda - invision activity report',
				'orders-api',
				'photo-files-api',
				'qc-intelligence-api',
				'qc-intelligence-backend-services',
				'reports-service',
				'reports-service-ssr',
				'reports-web-app',
				'rule-engine',
				'telemetry-api',
				'users'
			]
		},
		'cv.rule-engine.ux': {
			name: 'Rule Engine',
			logo: 'assets/img/brand/rule-engine.svg',
			key: 'rule-engine',
			dependencies: [
				'docsys',
				'ids',
				'rule-engine',
				'users'
			]
		},
		'cv.user-management.ux': {
			name: 'User Management',
			logo: 'assets/img/brand/user-management.svg',
			key: 'identity-system',
			dependencies: [
				'docsys', 
				'ids', 
				'users'
			]
		},
		'cv.global-configuration.ux': {
			name: 'Global configuration',
			logo: 'assets/img/brand/global-configuration.svg',
			key: 'global-configuration',
			dependencies: [
				'orders-api', 
				'ids', 
				'nexsys-api'
			]
		}
	};
}